import { render, staticRenderFns } from "./ChatSidebar.vue?vue&type=template&id=68dc6068&scoped=true&"
import script from "./ChatSidebar.vue?vue&type=script&lang=js&"
export * from "./ChatSidebar.vue?vue&type=script&lang=js&"
import style0 from "./ChatSidebar.vue?vue&type=style&index=0&id=68dc6068&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68dc6068",
  null
  
)

export default component.exports